import { FC, useEffect, useState } from 'react'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import { useAuth } from '../auth'
import { getAccount } from './core/_requests'
import { dataOf } from './core/errors'
import { AccountOverview } from './core/_models'
import { usePasswordPrompt } from './components/CurrentPasswordModal'
import { PasswordCard } from './components/PasswordCard'
import { SecondFactorCard } from './components/SecondFactorCard'
import { PasskeysCard } from './components/PasskeysCard'

const breadcrumbs: Array<PageLink> = [
  { title: 'Учётная запись', path: '/account', isSeparator: false, isActive: false },
]

/** The signed-in person's own password and second factor. */
export const AccountPage: FC = () => {
  const { setCurrentUser } = useAuth()
  const { ask, prompt } = usePasswordPrompt()
  const [overview, setOverview] = useState<AccountOverview | null>(null)
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    let alive = true
    getAccount()
      .then((response) => alive && setOverview(dataOf(response)))
      .catch(() => alive && setFailed(true))

    return () => {
      alive = false
    }
  }, [])

  const apply = (next: AccountOverview) => {
    setOverview(next)
    // the header warning follows the account without a reload
    setCurrentUser((user) => (user ? { ...user, secondFactorEnabled: next.secondFactorEnabled } : user))
  }

  return (
    <>
      <PageTitle breadcrumbs={breadcrumbs}>Учётная запись</PageTitle>

      {failed && <div className='alert alert-danger'>Не удалось загрузить данные учётной записи.</div>}
      {!failed && !overview && (
        <div className='d-flex align-items-center gap-3 text-muted'>
          <span className='spinner-border spinner-border-sm' /> Загружаем...
        </div>
      )}

      {overview && (
        <>
          <div className='card mb-7'>
            <div className='card-body d-flex align-items-center gap-3'>
              <span className='text-muted'>Логин</span>
              <span className='fw-bold fs-4 text-break'>{overview.login}</span>
            </div>
          </div>
          <PasswordCard />
          <SecondFactorCard overview={overview} ask={ask} onChange={apply} />
          <PasskeysCard overview={overview} ask={ask} onChange={apply} />
        </>
      )}

      {prompt}
    </>
  )
}
